import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_BREED_RESTRICTIONS } from 'api/actionTypes';

export default async function getBreedRestrictions(
  { state, apiClient },
  { listingId, withPartnerCascade, reload },
) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('withPartnerCascade::Maybe Boolean', withPartnerCascade);
  typeCheck('reload::Maybe Boolean', reload);

  const statePath = ['breedRestrictions', 'byListingId', listingId];
  if (!reload && state.get(statePath)) {
    return state.get(statePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_GET_BREED_RESTRICTIONS,
    state: state,
    queryId: `${listingId}${withPartnerCascade ? '-withPartnerCascade' : ''}`,
    payload: {
      listingId,
      withPartnerCascade,
    },
    onSuccess(breedRestrictions) {
      state.set(statePath, breedRestrictions);
    },
  });
}
